import { Component, HostBinding, Input, OnChanges } from '@angular/core';

import { EventModel, EventScoreboard, PairGameScore } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { SportConstant } from '@frontend/sports/common/core/data-access/constants';

@Component({
    selector: 'ms-special-game-scoreboard',
    templateUrl: 'special-game-scoreboard.html',
})
export class SpecialGameScoreboardComponent implements OnChanges {
    @Input() event: EventModel;
    @Input() scoreboard: EventScoreboard;
    @Input() isNewEDPScoreboard = false;

    @HostBinding('class') className = 'special-game';

    constructor(public sitecore: Sitecore) {}

    score: PairGameScore;
    displayMessage = '';
    sportType = SportConstant;

    ngOnChanges(): void {
        this.score = this.event.scoreboard.getScore<PairGameScore>()!;
        this.displayMessage = this.getDisplayMessage();
    }

    private getDisplayMessage(): string {
        if (this.event.scoreboard.isSuspended || this.event.scoreboard.isFinished) {
            return this.score.period;
        }

        return this.sitecore.freeBetOverview.messages?.Live ?? '';
    }
}
